<template>
    <div class="create-post scrollBar">
       <v-dialog v-model="dialog" content-class="create-content-dialog" persistent>
            <div class="create-content-dialog-container">
                <v-form @submit.prevent ref="createPollRef">
                    <v-text-field 
                        :rules="appliedRules"
                        class="create-content-input" 
                        outlined 
                        placeholder="Your campaign name here.."
                        v-model="campaignName">
                        <!-- <p slot="append" class="my-0 pointer appender --blue --weight"> Create a Poll </p> -->
                    </v-text-field>
                    
                    <hr style="border: 0.5px solid #E3E3E3; background-color : #E3E3E3; color : #E3E3E3">

                    <v-textarea 
                        :rules="appliedRules"
                        class="create-content-input" 
                        height="100" 
                        outlined 
                        placeholder="Write your question / query here.."
                        counter=""
                        v-model="description"
                        maxlength="500">
                    </v-textarea>

                    <div class="answers">
                        <v-text-field 
                            class="answer-input"
                            v-for="(input, index) in answers" 
                            :key="index"
                            outlined
                            placeholder="Add your answers here"
                            hide-details=""
                            append-icon="mdi-close"
                            @click:append="deleteOptions(index)"
                            v-model="answers[index].text">

                            <div class="alphabets --blue --weight" slot="prepend-inner">
                                {{ input.index }}
                            </div>
                        </v-text-field>

                        <div class="append-input --blue pointer flex" @click="addAnswerInput">
                            <div>
                                <img src="@/assets/MainDashboard/CreateContent/CreatePoll/add.svg" alt="">
                            </div>
                            Add another option
                        </div>
                    </div>
                    

                    <div class="buttons-section flex">
                        <button class="close" @click="$emit('close')">
                            <v-icon color="#247CC7">mdi-close</v-icon>
                        </button>
                        <button class="--blue draft" v-ripple @click.prevent="checkTypeAndAct(true)">Save as a draft</button>
                        <button class="publish blue-background white--text bold" v-ripple @click.prevent="checkTypeAndAct(false)">PUBLISH POLL</button>
                    </div>

                    <v-progress-linear indeterminate class="mt-1" color="#247CC7" v-if="loader"></v-progress-linear>
                </v-form>
            </div>
       </v-dialog>
    </div>
</template>

<script>
import accessToken from '../../../../helpers/accessToken';
import API_URL from '../../../../helpers/apiUrls'
import rules from '../../../../helpers/rules';
import MoengageEventGenerator from "../../../../helpers/moengageEventGenerator";
import MoengageEvents from "../../../../helpers/moengageEvents";
import MoengageAttributes from "../../../../helpers/moengageAttributes";
import getCurrent from "../../../../helpers/methods";
export default {
    name : 'createPollModal',

    data() {
        return {
            campaignName : '',
            description : '',
            answers : [
                {   index : 'A',
                    text : ''
                },
                {   index : 'B',
                    text : ''
                },
            ],
            loader : false,
            rules : rules,
            appliedRules : [],
            pollID : null
        }
    },

    props : {
        dialog : {
            type : Boolean,
            default : false
        },

        type : {
            type : String
        }
    },

    watch : {
        dialog : function(value) {
            if(!value) {
                this.answers = [
                    {   index : 'A',
                        text : ''
                    },
                    {   index : 'B',
                        text : ''
                    },
                ]
                this.campaignName = '';
                this.description = '';
                this.$refs.createPollRef.reset();
            }
        }
    },

    computed : {
        isSuperAdmin() {
            console.log('computed',this.$store.getters['mainStore/GET_SUPER_ADMIN'])
            return this.$store.getters['mainStore/GET_SUPER_ADMIN'];
        }
    },


    methods : {
        addAnswerInput() {
            let nextCharacter = String.fromCharCode(this.answers[this.answers.length - 1].index.charCodeAt(0) + 1);
            this.answers.push({
                index : nextCharacter,
                text : ''
            })
        },

        validateAnswerInput() {
            if(!this.answers.length)
                return false;
            else if(this.answers[0].text && this.answers[1].text) {
                return true;
            }
            this.showToast('Please add atleast 2 options!', 'error', 10000);
            return false;
        },

        deleteOptions(index) {
            if(index === 0 || index === 1) 
                this.answers[index].text = '';
            else 
                this.answers = this.answers.filter(option => this.answers[index] != option );
        },

        checkTypeAndAct(isDraft) {
            if(this.type === 'edit') 
                this.editAPoll(isDraft);
            else
                this.createAPoll(isDraft);
        },

        createAPoll(isDraft = false) {
            this.appliedRules.push(this.rules.required);
            if(this.$refs.createPollRef.validate() && this.validateAnswerInput()) {
                this.loader = true;
                const successHandler = response => {
                    if(response.status === 201) {
                        this.$emit('close');
                        this.$emit('refreshList');

                        if(isDraft)
                            this.showToast('The poll has been successfully drafted!')
                        else {
                    this.showToast('The poll has been successfully published!')
                    const moengageAttr = {
                    [MoengageAttributes.IsUserGenerated]: "TRUE",
                    [MoengageAttributes.BrandName]:localStorage.getItem("Brand-Name"),
                    [MoengageAttributes.BrandId]: localStorage.getItem("Brand-ID"),
                    [MoengageAttributes.DateofContentCreation]:
                    getCurrent.getCurrentDate(),
                    [MoengageAttributes.TimeofContentCreation]:
                    getCurrent.getCurrentTime(),
                    [MoengageAttributes.contentType]: "poll",
              };
              MoengageEventGenerator(
                MoengageEvents.BusinessContentCreated,
                moengageAttr
              );
                        }
                        
                        this.loader = false;
                        this.$refs.createPollRef.reset();
                    }
                }

                const errorHandler = error => {
                    this.showToast('Something went wrong internally!', 'error', 10000);

                    this.loader = false;
                }

                const data = {
                    campaign_name : this.campaignName,
                    text : this.description,
                    poll_options : this.answers,
                    is_draft : isDraft
                }

                const headers = {
                    'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                    'BRAND-ID' : localStorage.getItem("Brand-ID")  
                }

                this.requestPOST(
                   this.$store.getters['mainStore/GET_SUPER_ADMIN']?API_URL.createPoll_Admin:  API_URL.createPoll,
                    data,
                    headers,
                    successHandler,
                    errorHandler
                )
            }
        },

        editAPoll(isDraft) {
            this.appliedRules.push(this.rules.required);
            if(this.$refs.createPollRef.validate() && this.validateAnswerInput()) {
                this.loader = true;
                const successHandler = response => {
                    if(response.status === 200) {
                        this.$emit('close');
                        this.$emit('refreshList');

                        if(isDraft)
                            this.showToast('The poll has been successfully drafted!')
                        else
                            this.showToast('The poll has been successfully published!')
                        
                        this.loader = false;
                        this.$refs.createPollRef.reset();
                    }
                }

                const errorHandler = error => {
                    this.showToast('Something went wrong internally!', 'error', 10000);
                    this.loader = false;
                }

                const data = {
                    campaign_name : this.campaignName,
                    text : this.description,
                    poll_options : this.answers,
                    is_draft : isDraft
                }

                const headers = {
                    'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                    'BRAND-ID' : localStorage.getItem("Brand-ID")  
                }

                this.requestPOST(
                    this.$store.getters['mainStore/GET_SUPER_ADMIN']?`${API_URL.createContent__updateOrDelete_Admin}${this.pollID}/poll_update`: `${API_URL.createContent__updateOrDelete}${this.pollID}/poll_update`,
                    data,
                    headers,
                    successHandler,
                    errorHandler
                )
            }
        }
    }
}
</script>

<style lang="scss" scoped>


.create-content-dialog-container {
    background-color: white;
    font-family: Roboto;
    padding: 20px;
} 

.appender {
    font-size: 0.9rem;
}

hr {
    margin-top: -10px;
}

.alphabets {
    background: #F3F7FC;
    border-radius: 5px;
    padding: 13px 15px;
    transform: translateY(-10px);
}

.answer-input {
    margin-bottom: 10px;
}

.append-input {
    border: 0.5px solid #E1E1E1;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 10px;
    justify-content: flex-start;
    margin-bottom: 40px;
}

.append-input > div {
    background: #F3F7FC;
    border-radius: 5px;
    padding: 10px 15px;
    margin-right: 30px;
}

.buttons-section {
    justify-content: space-between;
}

button {
    border-radius: 5px;
    font-size: 1rem;
    padding: 20px 0;
}

.close {
    width: 10%;
}

.close, .draft {
    background: rgba(49, 138, 54, 0.05);
}

.draft, .publish {
    width: 44%;
}

@media all and (min-width : 1400px) {
    .upload__attach label {
        font-size: 1rem;
    }
}

</style>

<style lang="scss">

.answer-input input {
    padding-left: 25px !important;
}

.create-content-dialog.v-dialog {
    width: 60%;
}

.create-content-input fieldset {
    color: white !important;
}

.answer-input fieldset {
    color: #E1E1E1 !important;
}

@media all and (min-width : 1500px) {
    .create-content-dialog.v-dialog {
        width: 50%;
    }
}

</style>